import { call, put, takeLatest } from 'redux-saga/effects'
import {
  changeSectorMemberSuccess,
  changeSectorMemberFailed,
  CHANGE_SECTOR_MEMBER_START,
} from '../../actions/sector'
import { api } from '~/services/api/gameApi'

/**
 * change member sector pools api
 * @param {any} params Params will be sent to server
 * @returns {Promise}
 */
const changeMemberSectorsApi = (props) => {
  var uri = `/api/game/sector/change-user-sector`
  return api.post(uri, props)
}

/**
 * [Worker]
 * Handle get data request and response
 * @param {object} action
 */
function* doChangeMemberSectors(action) {
  try {
    const response = yield call(changeMemberSectorsApi, action?.payload)
    yield put(changeSectorMemberSuccess(response))
    // Call callback action if provided
    if (action.onSuccess) {
      yield action.onSuccess(response)
    }
  } catch (error) {
    yield put(changeSectorMemberFailed())
    // Call callback action if provided

    if (action.onError) {
      yield action.onError(error)
    }
  }
}

/**
 * [Watcher]
 * Watch change member sector pools
 */
export default function* watchChangeMemberSector() {
  yield takeLatest(CHANGE_SECTOR_MEMBER_START, doChangeMemberSectors)
}
